import { api } from 'api/api';
import { Endpoints } from 'api/constants';

interface SendPushNotification {
  employeeId: string;
  title: string;
  body: string;
  deeplink: string;
}

export const loaders = {
  sendPushNotification: (data: SendPushNotification) => {
    return api({
      url: Endpoints.melpAdmin.notifications.push,
      data: {
        employeeId: data.employeeId,
        title: data.title,
        body: data.body,
        deeplink: data.deeplink,
      },
      method: 'post',
    });
  },
};
